import { DocumentCard } from "./document-card";
import { FolderCard } from "./folder-card";
import type { DocumentFile } from "@/types/documents";
import type { Container } from "@/types/container";
import type { CustomFolder } from "@/types/documents";
import type { ViewMode } from "@/types/documents";

interface DocumentListProps {
    documents?: DocumentFile[];
    containers?: Container[];
    customFolders?: CustomFolder[];
    viewMode?: ViewMode;
    selectedItems?: string[];
    onDocumentClick?: (document: DocumentFile) => void;
    onDocumentContextMenu?: (document: DocumentFile, e: React.MouseEvent) => void;
    onDocumentCheckboxChange?: (document: DocumentFile, checked: boolean) => void;
    onContainerClick?: (container: Container) => void;
    onContainerContextMenu?: (container: Container, e: React.MouseEvent) => void;
    onCustomFolderClick?: (folder: CustomFolder) => void;
    onCustomFolderContextMenu?: (folder: CustomFolder, e: React.MouseEvent) => void;
    className?: string;
}

export const DocumentList = ({
    documents = [],
    containers = [],
    customFolders = [],
    viewMode = "card",
    selectedItems = [],
    onDocumentClick,
    onDocumentContextMenu,
    onDocumentCheckboxChange,
    onContainerClick,
    onContainerContextMenu,
    onCustomFolderClick,
    onCustomFolderContextMenu,
    className,
}: DocumentListProps) => {
    const containerClass = viewMode === "card"
        ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4"
        : "space-y-1";

    return (
        <div className={containerClass + (className ? ` ${className}` : "")}>
            {/* Custom Folders */}
            {customFolders.map((folder) => (
                <FolderCard
                    key={`folder-${folder.id}`}
                    type="custom_folder"
                    customFolder={folder}
                    viewMode={viewMode}
                    isSelected={selectedItems.includes(`folder-${folder.id}`)}
                    onClick={() => onCustomFolderClick?.(folder)}
                    onContextMenu={(e) => onCustomFolderContextMenu?.(folder, e)}
                />
            ))}

            {/* Container Folders */}
            {containers.map((container) => (
                <FolderCard
                    key={`container-${container.id}`}
                    type="container"
                    container={container}
                    viewMode={viewMode}
                    isSelected={selectedItems.includes(`container-${container.id}`)}
                    onClick={() => onContainerClick?.(container)}
                    onContextMenu={(e) => onContainerContextMenu?.(container, e)}
                />
            ))}

            {/* Documents */}
            {documents.map((document) => (
                <DocumentCard
                    key={document.id}
                    document={document}
                    viewMode={viewMode}
                    isSelected={selectedItems.includes(document.id)}
                    onClick={() => onDocumentClick?.(document)}
                    onContextMenu={(e) => onDocumentContextMenu?.(document, e)}
                    onCheckboxChange={onDocumentCheckboxChange ? (checked) => onDocumentCheckboxChange(document, checked) : undefined}
                    showCheckbox={!!onDocumentCheckboxChange}
                />
            ))}
        </div>
    );
};

